import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { nakajitsuPageMeta, nakajitsuSchema } from 'components/common/schema'
import Template from 'components/cases/nakajitsu'

const Nakajitsu: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...nakajitsuPageMeta} />
      <JsonLd data={nakajitsuSchema} />
      <Template />
    </>
  )
}

export default Nakajitsu
